module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("Campaigns Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "campaign-summary-total"
  }, [_c('span', {
    staticClass: "campaign-summary-total__count"
  }, [_vm._v("(" + _vm._s(_vm.totalCount) + ")")]), _vm._v(" "), _c('span', [_vm._v("Total")])])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": "",
      "color": "background-white"
    }
  }, _vm._l((_vm.summaryList), function(item, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.changeRoute(item)
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v(_vm._s(item.aIcon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.value))]), _vm._v("\n              " + _vm._s(item.value >= 2 ? 'Campaigns' : 'Campaign') + "\n            ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-789effc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/CampaignSummary.vue
// module id = 2208
// module chunks = 0